export default "__VITE_ASSET__8b2a95e2__"